function getOffersRequestOneData(args, locale, reqID, apiKey, isEnrolled, treatmentID) {
  const geoCenter = args.query.cl && args.query.cl.split(',');
  const geoTopLeft = args.query.nw && args.query.nw.split(',');
  const geoBottomRight = args.query.se && args.query.se.split(',');
  const customerTreatmentStatus = isEnrolled ? 'ENROLLED' : 'ELIGIBLE';
  const offersRequest = {
    globalRequest: {
      clientIdentifier: 'AmexMaps',
      viewIdentifier: 'OffersTab',
      channelIdentifier: 'WEB',
      locale,
      requestTimestamp: new Date().toISOString(),
      requestIdentifier: reqID,
    },
    userIdentification: {
      cardObjects: [
        {
          accountToken: apiKey,
        },
      ],
    },
    treatmentRequestParameters: {
      sortOrder: 'BYLOCATION',
      requestLocation: {
        geoCenter: {
          latitude: geoCenter ? Number(geoCenter[0]) : 37.2756537,
          longitude: geoCenter ? Number(geoCenter[1]) : -104.6561154,
        },
        geoTopLeft: {
          latitude: geoTopLeft ? Number(geoTopLeft[0]) : 68.8450197865529,
          longitude: geoTopLeft ? Number(geoTopLeft[1]) : -158.53736828110374,
        },
        geoBottomRight: {
          latitude: geoBottomRight ? Number(geoBottomRight[0]) : 21.609764458333082,
          longitude: geoBottomRight ? Number(geoBottomRight[1]) : -57.28736828110373,
        },
      },
      treatmentFilters: {
        domains: [
          'Merchant',
        ],
        componentIdentifiers: [
          'NearBy',
        ],
        customerTreatmentStatuses: [
          customerTreatmentStatus,
        ],
      },
    },
  };

  if (treatmentID) {
    offersRequest.treatmentRequestParameters.treatmentFilters.treatmentIdentifiers = [
      {
        domain: 'Merchant',
        treatmentIdentifier: treatmentID,
      },
    ];
  }

  return offersRequest;
}

export default getOffersRequestOneData;
